export default defineNuxtPlugin(() => {
  const toast = useToast();
  const connection = useState("connection", () => navigator.onLine);

  const update = () => {
    const isOnline = navigator.onLine;

    if (connection.value !== isOnline) {
      connection.value = isOnline;

      toast.add({
        title: isOnline ? "Back online" : "Connection lost",
        description: isOnline ? "Connection restored." : "Your device is offline.",
        icon: isOnline ? "i-lucide-wifi" : "i-lucide-wifi-off",
        color: isOnline ? "green" : "red",
        duration: isOnline ? 3000 : 5000,
      });
    }
  };

  window.addEventListener("online", update);
  window.addEventListener("offline", update);
});
